app.controller('baseOfCaseVisitHistoryController', ['$scope', '$state', '$stateParams', '$translate', 'objectHelper', 'baseModel', 'applicationModel', 'visitModel', 'userModel', 'patientModel', 'allergyModel', 'vaccinationAndSerumModel', 'takenDrugModel', 'geneticDisorderModel', 'baseOfCaseModel',
    function ($scope, $state, $stateParams, $translate, objectHelper, baseModel, applicationModel, visitModel, userModel, patientModel, allergyModel, vaccinationAndSerumModel, takenDrugModel, geneticDisorderModel, baseOfCaseModel) {

        function setData() {
            $scope.visitHistory = {};

            $scope.gridColumns = [
                {
                    field: "date | date: 'short'",
                    displayName: $translate.instant('T.MODULE.BASE_OF_CASE.DATE')
                },
                {
                    field: "visitType | prefix:'T.ENUM.VISIT_TYPE.' | translate",
                    displayName: $translate.instant('T.MODULE.BASE_OF_CASE.VISIT_TYPE')
                },
                {
                    cellTemplate: 'edm/application/view/app/baseOfCase/grid-template/data-grid-base-of-case-visit-history-main-diagnosis-row-template.html',
                    displayName: $translate.instant('T.MODULE.BASE_OF_CASE.DIAGNOSIS')
                }
            ];

            $scope.idVisitCard = $stateParams.idVisitCard;

            $scope.gridCriteria = objectHelper.createObject(VisitDataGridCriteria, {
                rowsPerSheet: 20
            });
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on(Event.BASE_OF_CASE.GET_ANONYMIZED_VISIT_HISTORY.SUCCESS, function(event, visitHistory) {
                $scope.visitHistory = visitHistory;
            });

            $scope.criteriaChanged = function () {
                baseOfCaseModel.getAnonymizedVisitHistory($stateParams.idVisitCard, $scope.gridCriteria);
            };
        }

        function setActions() {
            $scope.goToSearchPage = function () {
                $state.go(Constant.STATE.APP.BASE_OF_CASE.SEARCH);
            };
        }

        function configureInterface() {
        }

        function initialize() {
            baseOfCaseModel.getAnonymizedVisitHistory($stateParams.idVisitCard, $scope.gridCriteria);
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        initialize();
        configureInterface();
    }
]);